export const FETCH_ALL_FAQS = "FETCH_ALL_FAQS";
export const FETCH_FAQ = "FETCH_FAQ";
export const CREATE_FAQ = "CREATE_FAQ";
export const UPDATE_FAQ = "UPDATE_FAQ";
export const DELETE_FAQ = "DELETE_FAQ";
